import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { epicContractInfoFactory } from "./epicContractInfoFactory";
export var epicContractInfoRequestOnReconnect = epicContractInfoFactory(TypeActionPlayerInfo.Received);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoRequestOnReconnect.ts
// module id = 1998
// module chunks = 3